import React, {
    Fragment,
    useEffect,
    useState,
    useRef,
    useCallback,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import GoogleMapReact from 'google-map-react';
import useSupercluster from 'use-supercluster';
//import { MarkerClusterer } from "@googlemaps/markerclusterer";
import Marker from './Marker';
import ClusterMarker from './ClusterMarker';

import PlacesAutocomplete from './PlacesAutocomplete';
//import ClusterMarker from './ClusterMarker';
import { query, changeMode } from '../../Actions/DealerInfo.action';
import { translate } from '../../Services/translation';
import constants, { ViewMode, gmId } from '../../constants';
import mapStyles from './mapStyles';
import { calcDistance, sortDistances } from './mapFunctions';

const DealerInfoContainer = () => {
    const mapRef = useRef();
    const list = useSelector((state) => state.dealerInfo.list);
    const dispatch = useDispatch();
    const [autocompleteFocusIndex, setAutocompleteFocusIndex] = useState(-1);
    const [mapApi, setMapApi] = useState();
    const [placesService, setPlacesService] = useState();
    const [mapInstance, setMapInstance] = useState();
    const [mapApiLoaded, setMapApiLoaded] = useState(false);
    const [selectedDealer, setSelectedDealer] = useState('');
    const [googleMapsKey, setGoogleMapsKey] = useState(constants.gmId);

    const [zoom, setZoom] = React.useState(5);
    const [dealers, setDealers] = useState([]);
    const [segments, setSegments] = React.useState([]);
    const [dealerTypes, setDealerTypes] = React.useState([]);
    const [activeDealerType, setActiveDealerType] = useState('all');
    const [filterSegments, setFilterSegments] = React.useState([]);
    const [mounted, setMounted] = useState(false);
    const [loadCards, setLoadCards] = useState(false);
    const [positioningEnabled, setPositioningEnabled] = useState(true);
    const [positionInit, setPositionInit] = useState(false);

    const [initSegmentValue, setSegmentValue] = useState({});
    const [initTypeValue, setTypeValue] = useState({});
    const [initTextValue, setTextValue] = useState({});


    const [position, setPosition] = useState({
        // Default: Öhlins Reseller Network, Stockholm
        lat: 59.344780380234646,
        lng: 18.048064024644894,
    });
    const [positionLocal, setPositionLocal] = useState({
        lat: 0,
        lng: 0,
    });

    // Clusetering
    const [bounds, setBounds] = useState(null);
    const points = dealers.map((dealer, dealerIndx) => ({
        type: 'Feature',
        properties: {
            cluster: false,
            dealerIndex: `dealerMarkers${dealerIndx}`,
            name: dealer.name,
        },
        geometry: {
            type: 'Point',
            coordinates: [parseFloat(dealer.longitude), parseFloat(dealer.latitude)],
        },
    }));
    const { clusters, supercluster } = useSupercluster({
        points,
        bounds,
        zoom,
        options: { radius: 75, maxZoom: 22 },
    });
    // End Clusetering

    useEffect(() => {
        dispatch(query());
    }, [dispatch]);

    useEffect(() => {
        async function setup() {
            const queryString = window.location.search;

            const params = new URLSearchParams(queryString);
            const segmentString = params.get("segment");
            const segmentsArray = segmentString ? segmentString.split(",") : [];
            if (segmentsArray.length > 0) {
                setFilterSegments(segmentsArray);
            }
            const type = params.get("type");
            if (type.length > 0) {
                setActiveDealerType(type);
            }
            //const urlType = { value: urlParams.get('type') };
            //setTypeValue(urlType);
            //const urlText = { value: urlParams.get('text') };
            //setTextValue(urlText);
        }
        setup();
    }, []);

    const insertUrlParam = (key, value) => {
        if (history.pushState) {
            const url = new URL(window.location);
            url.searchParams.set(key, value);
            window.history.pushState(null, '', url.toString());
        }
    };

    const removeUrlParameter = (paramKey) => {
        const url = window.location.href;
        const updatedUrl = new URL(url);
        updatedUrl.searchParams.delete(paramKey);
        const newUrl = updatedUrl.href;
        window.history.pushState({ path: newUrl }, '', newUrl);
    };

    const toggleUrlVal = (key, value, remove = false) => {
        if (!remove && value) {
            insertUrlParam(key, value);
        } else {
            dispatch(removeUrlParameter(key));
        }
    };
    const setNewLocation = (newPosition) => {
        setPosition(newPosition);
        setFilters([...filterSegments], activeDealerType);
    };
    const setDistances = (currentSegmentsDealerData) => {
        const positionMeassureFrom = position;

        if (positionMeassureFrom.lat != 0) {
            currentSegmentsDealerData.map((dealer, index) => {
                const dealerPos = {
                    lat: dealer.latitude,
                    lng: dealer.longitude,
                };
                const distance = calcDistance(positionMeassureFrom, dealerPos);
                currentSegmentsDealerData[index] = { ...dealer, distance };
            });
        }
        return currentSegmentsDealerData;
    };

    const equalsCheck = (a, b) =>
        a.length === b.length && a.every((v, i) => v === b[i]);

    const setDistancesAndSort = (currentSegmentsDealerData) => {
        if (currentSegmentsDealerData && currentSegmentsDealerData.length > 0) {
            currentSegmentsDealerData = setDistances(currentSegmentsDealerData);
            currentSegmentsDealerData.sort(sortDistances);
        }

        //const slicesDealers = currentSegmentsDealerData.slice(0, 2200);
        //if (dealers.length !== slicesDealers.length) {
        //setDealers(slicesDealers);
        setDealers(currentSegmentsDealerData);
    };

    const currentlyShown = (location, bounds) => {
        if (bounds) {
            const visible =
                bounds.getNorthEast().lat() > location.lat &&
                bounds.getNorthEast().lng() > location.lng &&
                bounds.getSouthWest().lat() < location.lat &&
                bounds.getSouthWest().lng() < location.lng;
            return visible;
        } else {
            return true;
        }
    };

    const handleApiLoaded = (map, maps) => {
        setMapApi(map);
        setMapInstance(maps);
    };

    const addPlace = (place) => {
        this.setState({ places: [place] });
    };

    const selectDealer = (name, index) => {
        setSelectedDealer(name);
    };

    // Setting all unique segments (Filtering by buttons) + filtering out all non selected segments
    const setFilters = (newFilterList = null, filterDealerType = null) => {
        if (list && list.length > 0) {
            let currentSegments = [...segments];
            let currentDealerTypes = [...dealerTypes];
            let currentSegmentsDealerData = [];
            if (!filterDealerType) {
                filterDealerType = activeDealerType;
            }
            const currentSetFilters = newFilterList || [...filterSegments];
            list.map((dealer) => {
                const dealerSegments = dealer.segments;
                const itemDealerTypes = dealer.dealerTypes;

                const segmentNames = Array.from(dealerSegments, (x) => x.name);
                const segmentNamesUnique = segmentNames?.filter(
                    (x) => !currentSegments.includes(x)
                );

                if (
                    currentSetFilters.some((r) => segmentNames.indexOf(r) >= 0) ||
                    currentSetFilters.length < 1
                ) {
                    let dealerTypeExists = true;

                    if (
                        filterDealerType &&
                        filterDealerType !== 'all' &&
                        !dealer.dealerTypes.includes(filterDealerType)
                    ) {
                        dealerTypeExists = false;
                    }
                    if (dealerTypeExists) {
                        currentSegmentsDealerData.push(dealer);
                    }
                }
                if (!newFilterList) {
                    currentSegments = [...currentSegments, ...segmentNamesUnique];
                }

                if (!newFilterList) {
                    const typeNames = Array.from(itemDealerTypes, (x) => x);
                    const typeNamesUnique = typeNames?.filter(
                        (x) => !currentDealerTypes.includes(x)
                    );
                    if (!newFilterList) {
                        currentDealerTypes = [...currentDealerTypes, ...typeNamesUnique];
                    }
                }
            });
            if (!newFilterList) {
                setSegments([...currentSegments]);
                setDealerTypes([...currentDealerTypes]);
            }
            setDistancesAndSort(currentSegmentsDealerData);
        }
    };

    const toggleSegment = (segment) => {
        setSelectedDealer('');
        let newFilterList = [];
        if (filterSegments.includes(segment)) {
            newFilterList = filterSegments.filter((x) => x !== segment);
        } else if (typeof (segment) === 'string' && segment != '') {
            newFilterList = [...filterSegments, segment];
        }
        setFilterSegments(newFilterList);
        setFilters(newFilterList);
        if (newFilterList.length > 0) {
            toggleUrlVal('segment', newFilterList);
        } else {
            toggleUrlVal('segment', newFilterList, true);
        }
        scrollToDealer();

    };

    const toggleActiveDealerType = (e) => {
        setSelectedDealer('');
        const dealerType = e.target.value;
        setActiveDealerType(dealerType);
        setFilters([...filterSegments], dealerType);
        toggleUrlVal('type', dealerType);
        scrollToDealer();
    };
    const scrollToDealerListTop = () => {
        const dealerItemTop = document
            .querySelector('.dealer-page__dealer-list-container')
            ?.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const scrollToDealer = () => {
        setTimeout(() => {
            const dealerContainer = document.querySelector(
                '.dealer-page__dealer-list-container'
            );
            const dealerItem = document.querySelector(
                '.dealer-page__dealer-list-item--active'
            );

            // Will scroll smoothly to the top of the next section
            if (dealerContainer && dealerItem) {
                dealerContainer.scroll({
                    top:
                        dealerItem.offsetTop -
                        dealerContainer.offsetHeight / 2 +
                        dealerItem.offsetHeight / 2,
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'block',
                });
            } else {
                scrollToDealerListTop();
            }
        }, 400);
    };

    Array.prototype.unique = function () {
        var a = this.concat();
        for (var i = 0; i < a.length; ++i) {
            for (var j = i + 1; j < a.length; ++j) {
                if (a[i] === a[j]) a.splice(j--, 1);
            }
        }
        return a;
    };
    const initCards = () => {
        setMounted(true);
        setTimeout(() => {
            setMapApiLoaded(true);
            setTimeout(() => {
                setLoadCards(true);
            }, 500);
        }, 500);
    };
    const setPositionToCurrentLocation = () => {
        navigator.geolocation.getCurrentPosition(
            async function (position) {
                const coords = position.coords;
                setPositionInit(true);
                setPositioningEnabled(true);

                setPosition({
                    lat: coords.latitude,
                    lng: coords.longitude,
                });
                setPositionLocal({
                    lat: coords.latitude,
                    lng: coords.longitude,
                });

                initCards();
            },
            function (error) {
                initCards();
                setPositioningEnabled(false);
                setPositionInit(true);
            },
            { maximumAge: 60000, timeout: 5000, enableHighAccuracy: true }
        );
    };

    useEffect(() => {
        setPositionToCurrentLocation();
        async function setup() {
            if (!mounted) {
                setMounted(true);
                setZoom(10);
            }
        }
        setup();
    }, []);

    //useEffect(() => {

    //}, [activeDealerType]);

    useEffect(() => {
        if (mounted) {
            setFilters();
        }
    }, [setPositioningEnabled, list, position]);

    useEffect(() => {
        scrollToDealer();
        // Scoll to dealer in list
    }, [selectedDealer]);

    return (
        <Fragment>
            <div className="row dealer-page__form-wrapper">
                {loadCards && (
                    <Fragment>
                        <div className="small-12 medium-12 columns dealer-page__item--fade-in">
                            {false && filterSegments && filterSegments.length > 0 && (
                                <ul>
                                    {filterSegments.map((segment, segmentBtnIndex) => (
                                        <li key={`dalerList${segmentBtnIndex}`}>
                                            <button
                                                onClick={() => toggleSegment(segment)}
                                                className="segment__filter-button"
                                            >
                                                {segment}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {segments && segments.length > 0 && (
                                <ul className="dealer-page__filter-button-container">
                                    {segments.map((segment, segmentBtnIndex) => (
                                        <li
                                            className={`dealer-page__filter-button${(filterSegments.includes(segment)) ? '--active' : ''
                                                }`}
                                            key={`dalerList${segmentBtnIndex}`}
                                        >
                                            <button onClick={() => toggleSegment(segment)}>
                                                <span>{segment}</span>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        {mapApiLoaded && (
                            <PlacesAutocomplete
                                map={mapInstance}
                                mapApi={mapApi}
                                addplace={addPlace}
                                setNewLocation={setNewLocation}
                                dealers={dealers}
                                selectDealer={selectDealer}
                                autocompleteFocusIndex={autocompleteFocusIndex}
                                setAutocompleteFocusIndex={setAutocompleteFocusIndex}
                                scrollToDealerListTop={scrollToDealerListTop}
                                setZoom={setZoom}
                            />
                        )}

                        <div className="dealer-page__dealer-type-select-wrapper small-12 large-7 columns dealer-page__item--fade-in">
                            <label htmlFor="dpDealerType">{translate('dealer.type')}</label>
                            <div className="dealer-page__dealer-type-select-wrapper select-wrapper">
                                <select
                                    value={activeDealerType}
                                    className=""
                                    type="text"
                                    id="dpDealerType"
                                    name="dpDealerType"
                                    onChange={(e) => toggleActiveDealerType(e)}
                                >
                                    <option value="all"> {translate('dealer.type.all')} </option>
                                    {dealerTypes &&
                                        dealerTypes.map((dealerType, dealerTypeIndex) => (
                                            <option
                                                key={`dealerTypeList${dealerTypeIndex}`}
                                                value={dealerType}
                                            >
                                                {dealerType}
                                            </option>
                                        ))}
                                </select>
                                <i></i>
                            </div>
                        </div>
                    </Fragment>
                )}
            </div>

            <div className="dealer-page__map-container">
                {loadCards && dealers && dealers.length > 0 && (
                    <div
                        id="dealer-page__dealer-list-container"
                        className="dealer-page__dealer-list-container"
                    >
                        <ul className="dealer-page__dealer-list">
                            {dealers.map((dealer, index) => {
                                if (
                                    currentlyShown(
                                        /* If one only want to list dealers shown on map */
                                        { lat: dealer.latitude, lng: dealer.longitude },
                                        mapApi?.getBounds()
                                    )
                                ) {
                                    return (
                                        <li
                                            data-lat={dealer.latitude}
                                            id={`dealerPageListItem_${index}`}
                                            className={`dealer-page__item--fade-in dealer-page__dealer-list-item${selectedDealer === dealer.name ? '--active' : ''
                                                }`}
                                            key={`dalerList${index}`}
                                        >
                                            <address>
                                                <h4>{dealer.name}</h4>

                                                {(dealer.dealerAddressData.city ||
                                                    dealer.dealerAddressData.address) && (
                                                        <div className="dealer-page__dealer-list-item-address">
                                                            {dealer.dealerAddressData.city}
                                                            {dealer.dealerAddressData.city && (
                                                                <Fragment>, </Fragment>
                                                            )}
                                                            {dealer.dealerAddressData.address && (
                                                                <Fragment>
                                                                    {dealer.dealerAddressData.address}
                                                                </Fragment>
                                                            )}
                                                        </div>
                                                    )}
                                                {dealer.website && dealer.website.length > 1 && (
                                                    <div className="dealer-page__dealer-list-item-website">
                                                        <a
                                                            target="_blank"
                                                            href={
                                                                dealer.website.toLowerCase().indexOf('//') !==
                                                                    -1
                                                                    ? dealer.website
                                                                    : '//' + dealer.website
                                                            }
                                                        >
                                                            {dealer.website}
                                                        </a>
                                                    </div>
                                                )}
                                                {dealer.dealerAddressData.email && (
                                                    <div className="dealer-page__dealer-list-item-email">
                                                        <a
                                                            href={`mailto:${dealer.dealerAddressData.email.toLowerCase()}`}
                                                        >
                                                            {dealer.dealerAddressData.email}
                                                        </a>
                                                    </div>
                                                )}
                                                {dealer.dealerAddressData.phoneNumber && (
                                                    <div className="dealer-page__dealer-list-item-phone">
                                                        <a
                                                            href={`tel:${dealer.dealerAddressData.phoneNumber}`}
                                                        >
                                                            {dealer.dealerAddressData.phoneNumber}
                                                        </a>
                                                    </div>
                                                )}
                                            </address>
                                            {dealer.localUrl && (
                                                <div className="dealer-page__dealer-list-item-details">
                                                    <a
                                                        className="button link"
                                                        target="_blank"
                                                        href={dealer.localUrl}
                                                    >
                                                        See details
                                                    </a>
                                                </div>
                                            )}

                                            {/*<h5>{dealer.distance}</h5>*/}
                                            {false && dealer.segments && (
                                                <ul>
                                                    {dealer.segments.map((segment, segmentIndex) => (
                                                        <li key={`segmentList${segmentIndex}`}>
                                                            <a href={segment.url}>
                                                                {' '}
                                                                {segment.name}
                                                                <br />
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                    </div>
                )}

                <GoogleMapReact
                    yesIWantToUseGoogleMapApiInternals
                    bootstrapURLKeys={{
                        key: googleMapsKey,
                        libraries: ['places', 'geometry'],
                    }}
                    defaultZoom={zoom}
                    zoom={zoom}
                    center={position}
                    // Available styles: dark, default
                    options={{
                        zoomControl: true,
                        mapTypeControl: false,
                        disableDefaultUI: true,
                        styles: mapStyles.dark,
                        minZoom: 5,
                        maxZoom: 20,
                        gestureHandling: 'greedy',
                    }}
                    onChange={({ zoom, center, bounds }) => {
                        setZoom(zoom);
                        setPosition(center);
                        setBounds([
                            bounds.nw.lng,
                            bounds.se.lat,
                            bounds.se.lng,
                            bounds.nw.lat,
                        ]);
                    }}
                    onGoogleApiLoaded={({ map, maps }) => {
                        handleApiLoaded(map, maps);
                        mapRef.current = map;
                    }}
                >
                    {mapInstance &&
                        mapApiLoaded &&
                        clusters &&
                        clusters.length > 0 &&
                        clusters.map((cluster, index) => {
                            const [longitude, latitude] = cluster.geometry.coordinates;
                            const {
                                cluster: isCluster,
                                point_count: pointCount,
                            } = cluster.properties;

                            if (isCluster) {
                                return (
                                    <ClusterMarker
                                        key={`cluster-${cluster.id}`}
                                        lat={latitude}
                                        lng={longitude}
                                        name={cluster.properties.name}
                                        indx={`cluster-${cluster.id}`}
                                        supercluster={supercluster}
                                        mapRef={mapRef}
                                        points={points}
                                        pointCount={pointCount}
                                        cluster={cluster}
                                    />
                                );
                            }
                            if (
                                currentlyShown(
                                    { lat: latitude, lng: longitude },
                                    mapApi.getBounds()
                                )
                            ) {
                                return (
                                    /*   {mapInstance && dealers && dealers.length > 0 && dealers.map((dealer, index) => ( */
                                    <Marker
                                        key={cluster.properties.dealerIndex}
                                        lat={latitude}
                                        lng={longitude}
                                        name={cluster.properties.name}
                                        indx={cluster.properties.dealerIndex}
                                        isActive={selectedDealer === cluster.properties.name}
                                        {...{ selectDealer, cluster }}
                                    />
                                    //))}
                                );
                            }
                        })}
                </GoogleMapReact>
            </div>
        </Fragment>
    );
};
export default DealerInfoContainer;
